import { restRequest } from 'plugins/request';
import { QUERY_KEY_BLOCKS } from './index';

// Utils

export { QUERY_KEY_BLOCKS };

export const Bloks = restRequest(QUERY_KEY_BLOCKS);

export type BlocksData = {
  image: string;
  title: string;
  link: string;
  modulId: number;
};

export const apiGetBloks = async (params: {
  modulId?: number;
  lang?: string;
  otherParams?: any;
}): Promise<BlocksData> => {
  const { modulId, lang = '', otherParams } = params;

  return await Bloks.get('', false, false, {
    ...otherParams,
    modul_id: modulId,
    expand: 'translation',
    lang: lang,
  });
};
